import { environment } from '@env/environment';
import { Storage } from '@core/utils/storage';
import { AuthService } from '@core/services/auth/auth.service';
import { isTokenExpired } from '@core/utils/jwt.utils';
import { lastValueFrom } from 'rxjs';

export function initializeApp(authService: AuthService) {
  return async () => {
    // Validate authentication before app starts
    if (authService.token) {
      // Check if token is expired (auto-refresh is intentionally disabled - users logout after 24h)
      if (isTokenExpired(authService.token.access_token)) {
        // Token is expired, clear it and let user be redirected to login
        authService.logout();
      } else {
        // Token exists and is valid, verify with backend
        try {
          await lastValueFrom(authService.profile());
          // Profile loaded successfully
          // Note: Auto-refresh is disabled - users will be logged out when token expires (24h)
        } catch (error) {
          // Profile fetch failed (token might be invalid or network error)
          console.error('Failed to load user profile during app initialization:', error);
          authService.logout();
        }
      }
    }

    // Continue with Facebook SDK initialization
    return new Promise((resolve) => {
      window['fbAsyncInit'] = () => {
        FB.init({
          appId: environment.facebook.appId,
          cookie: environment.facebook.cookie,
          xfbml: environment.facebook.xfbml,
          version: environment.facebook.version,
        });

        // auto authenticate with the api if already logged in with facebook
        FB.getLoginStatus(({ authResponse }) => {
          if (authResponse) {
            Storage.setItem('fbAccessToken', authResponse.accessToken);
          } else {
            Storage.removeItem('fbAccessToken');
          }
          resolve(true);
        });
      };

      // load facebook sdk script
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        const js = d.createElement(s);
        js.id = id;
        (js as any).src = 'https://connect.facebook.net/en_US/sdk.js';
        (fjs as any).parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');

      /** ---------- Google Analytics Init ---------- */
      // console.log('Google Analytics initializing with ID:', environment.googleAnalyticsId);

      // const gaScript = document.createElement('script');
      // gaScript.async = true;
      // gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.googleAnalyticsId}`;
      // document.head.appendChild(gaScript);

      // gaScript.onload = () => {
      //   window.dataLayer = window.dataLayer || [];

      //   (window as any).gtag = function (...args: any[]) {
      //     window.dataLayer.push(args);
      //   };

      //   (window as any).gtag('js', new Date());
      //   (window as any).gtag('config', environment.googleAnalyticsId, {
      //     // debug_mode: true
      //   });
      //   (window as any).gtag('event', 'test_event', {
      //     event_category: 'debug',
      //     event_label: 'Test from App',
      //   });

      //   console.log('Google Analytics initialized ✅');
      //   resolve(undefined);
      // };

      // gaScript.onerror = (err) => {
      //   console.error('❌ Failed to load Google Analytics script:', err);
      //   resolve(undefined); // Still resolve to let the app load even if GA fails
      // };
    });
  };
}
